<template>
  <div class="ui top fixed menu borderless">
    <button
      class="item"
      :class="$style.transBtn"
      data-wd="backBtn"
      @click="$emit('back')"
    >
      <i class="chevron left icon" />
    </button>
    <div class="ui item" :class="$style.inputItem">
      <form
        :class="$style.form"
        role="search"
        data-wd="inSearch"
        @submit.prevent="search"
      >
        <div class="ui transparent input" :class="$style.inputCont">
          <input
            v-model="query"
            v-focus="inputFocused"
            type="search"
            :placeholder="$t('placeholder')"
            @focus="focus"
            @blur="inputFocused = false"
          />
        </div>
      </form>
    </div>
    <div class="right menu">
      <button
        v-show="!isQueryEmpty"
        class="item"
        :class="$style.transBtn"
        @click="clearQuery"
      >
        <i class="remove icon" />
      </button>
    </div>
  </div>
</template>

<script>
import { mixin as focusMixin } from 'vue-focus'

export default {
  name: 'RgToolbarSearch',
  mixins: [focusMixin],
  props: ['defaultVal', 'focused'],
  data () {
    return {
      query: '',
      inputFocused: false
    }
  },
  computed: {
    isQueryEmpty () {
      return !(this.query && this.query.length > 0)
    }
  },
  watch: {
    $route () {
      if (this.defaultVal) {
        this.query = this.defaultVal
      }
    }
  },
  created () {
    this.inputFocused = this.focused
    if (this.defaultVal) {
      this.query = this.defaultVal
    }
  },
  methods: {
    search () {
      this.$fa.logEvent(this.$fa.Event.SEARCH_BY_ELASTIC, { q: this.query })
      this.inputFocused = false
      this.$emit('search', this.query)
    },
    clearQuery () {
      this.query = ''
      this.inputFocused = true
    },
    focus () {
      this.inputFocused = true
      this.$emit('focus', this.inputFocused)
    }
  },
  i18n: {
    messages: {
      ko: {
        placeholder: '내 서재 전체 검색'
      },
      en: {
        placeholder: 'Search in "My library"'
      }
    }
  }
}
</script>

<style module>
@value transBtn from '~@/stylesheets/toolbar.css';

:global(.ui.menu .item).inputItem {
  flex-grow: 1;
  padding: 0;
}

.inputCont {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.form {
  width: 100%;

  & input {
    width: 100%;
  }
}
</style>
